import { apiCallback } from 'api';
import { ApiCallArgs } from 'api/types';
import { ApiError } from 'constants/errors';
import { SlotTypes } from 'constants/fulfilmentTypes';
import {
  BasketBuilderExperienceQuickShopWidgetResponse,
  BasketBuilderExperienceSuggestionsByCategoryResponse,
  BasketBuilderExperienceSuggestionsResponse,
} from './types';

const suggestionsDefinition = {
  service: 'basket-builder-experience',
  endpoint: 'suggestions',
  query: {
    customerOrderId: '${customerOrderId}',
    excludeSuggestionsInTrolley: '${excludeSuggestionsInTrolley}',
    size: '${size}',
    slotType: '${slotType}',
  },
  verbs: ['get'],
  defaultVersion: 1,
};

const getSuggestionsCallback = apiCallback(suggestionsDefinition, 'get');

const getSuggestions = (
  args: {
    excludeSuggestionsInTrolley?: boolean;
    size: number;
    slotType?: Omit<SlotTypes, 'UNDEFINED'>;
  } & ApiCallArgs,
): WtrApiCall<Promise<BasketBuilderExperienceSuggestionsResponse | ApiError>> =>
  getSuggestionsCallback(args);

const suggestionsByCategoryDefinition = {
  service: 'basket-builder-experience',
  endpoint: 'suggestions/by-category',
  query: {
    customerOrderId: '${customerOrderId}',
    offersAndPromosOnly: '${offersAndPromosOnly}',
    pageNumber: '${pageNumber}',
    slotType: '${slotType}',
  },
  verbs: ['get'],
  defaultVersion: 1,
};

const getSuggestionsByCategoryCallback = apiCallback(suggestionsByCategoryDefinition, 'get');

const getSuggestionsByCategory = (
  args: {
    offersAndPromosOnly?: boolean;
    pageNumber?: number;
    slotType?: Omit<SlotTypes, 'UNDEFINED'>;
  } & ApiCallArgs,
): WtrApiCall<Promise<BasketBuilderExperienceSuggestionsByCategoryResponse | ApiError>> =>
  getSuggestionsByCategoryCallback(args);

const quickShopWidgetDefinition = {
  service: 'basket-builder-experience',
  endpoint: 'widget/quick-shop',
  query: {
    customerOrderId: '${customerOrderId}',
    slotType: '${slotType}',
  },
  verbs: ['get'],
  defaultVersion: 1,
};

const getQuickShopWidgetCallback = apiCallback(quickShopWidgetDefinition, 'get');

const getQuickShopWidget = (
  args: {
    slotType?: Omit<SlotTypes, 'UNDEFINED'>;
  } & ApiCallArgs,
): WtrApiCall<Promise<BasketBuilderExperienceQuickShopWidgetResponse | ApiError>> =>
  getQuickShopWidgetCallback(args);

export default {
  getSuggestions,
  getSuggestionsByCategory,
  getQuickShopWidget,
};
